import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Constant } from 'src/app/common/constant';
import { environment } from 'src/environments/environment';
import {FileSaverService} from 'ngx-filesaver';
import { map } from 'rxjs';
@Injectable({ providedIn: 'root' })
export class  CustomComponentService {
    constructor(
        public http: HttpClient,
        private fileSaverService: FileSaverService
    ) {}
    changePass(body) {
        return this.http.post(environment.urlBackEnd + Constant.api_user_change_pass, body);
    }
    getProfile() {
        return this.http.get(environment.urlBackEnd +  Constant.api_user_profile);
    }
    postRequest(url, body) {
        return this.http.post(url, body);
    }
    getAgentProducts(body) {
        return  this.http.post(environment.urlBackEnd + Constant.api_common_agent_products_filter, body);
    }
    exportFile(url, data) {
        return this.http.post(environment.urlBackEnd + url, data, {responseType:'blob',  observe: 'events'})
        .pipe(map((res: any) => {
            if (res.body) {
                this.fileSaverService.save(res.body, res.headers.get('filename'));    
            }
            return res;
        }))
    }
}
